import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { LocalStorageService } from '../../services/local-storage.service';
import { LoaderService } from 'src/core/services/loader.service';
import { UtilsService } from 'src/core/services/utils.service';


@Component({
  selector: 'core-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit, AfterViewInit {
  theme_color: 'primary' | 'accent' | 'warn' = 'primary'; // ? notice this
  is_dark = false; // ? notice this

  @Output() theme_toggle = new EventEmitter<boolean>();
  isLoading: boolean = false;

  constructor(
    private overlayContainer: OverlayContainer, 
    private _ls: LocalStorageService,
    private loaderService: LoaderService,
    private utils: UtilsService
    ) { }

  ngOnInit(): void {
    this
    .loaderService
    .isLoading
    .subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  ngAfterViewInit(): void {
    this.is_dark = this._ls.get('THEME', 'DARK') === 'true' ? true : false;
    this.setTheme(this.is_dark);
    const mainNav = document.querySelector('#main-nav') as HTMLElement;
    this.utils.watchMainNavHeight(mainNav);
  }

  toggleTheme(): void {
    this.is_dark = !this.is_dark;
    this._ls.store('THEME', 'DARK', `${this.is_dark}`);
    this.setTheme(this.is_dark);
  }

  setTheme(is_dark:boolean) {
    this.theme_toggle.emit(is_dark);
    if (is_dark) {
      this.overlayContainer.getContainerElement().classList.add('dark-theme');
    } else {
      this.overlayContainer
        .getContainerElement()
        .classList.remove('dark-theme');
    }
  }

}
